import { useState, useEffect } from 'react'
import Layout from '../../layout'
import { useLocation, useNavigate,useParams } from 'react-router-dom'
import { GetOutletManagementList } from '../../services/outletManagementService'
import CustomPagination from '../../components/common/customPaginationAdmin'
import { formateDate } from '../../helpers/commonFunctions';
import Sorting from '../../components/common/sorting';
import Loader from '../../components/common/loader'
import Breadcrums from '../../components/common/breadcrumbs'
import StatusFilter from '../../components/common/statusFilter'
import { showFilterlist } from '../../utils/Constants'
import $ from "jquery";
import ViewAllDetails from '../company/viewAllDetails'

const OutletManagementTable = () => {

    const breadcrumbs = [{ title: "Dashboard", url: "/admin/dashboard" },{ title: "Companies", url: "/admin/company/list/1" }, { title: "Outlets", url: "" },]
    const navigate = useNavigate()
    const params = useParams()
    const location = useLocation()
    const [list, setList] = useState([])
    const [statsUpdate] = useState("false")
    const [dataLength, setDataLength] = useState()
    const [itemPerPage] = useState(10)
    const [sorting, setSorting] = useState({});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [page, setPage] = useState(1);
    const [loader, setLoader] = useState(true)
    const [search, setSearch] = useState({})
    const [globalSearch, setGlobalSearch] = useState("")
    const [resetdate, setResetDate] = useState(false)

    const companyId = params?.id;

    useEffect(() => {
        if (search) {
            setLoader(true)
            const formData = new FormData()
            formData.append("page", params.pgno)
            formData.append("per_page", itemPerPage)
            formData.append("sort", JSON.stringify(sorting))
            formData.append("search", JSON.stringify(search))
            formData.append("global_search", globalSearch)
            formData.append("company_id", companyId)
            GetOutletManagementList(formData).then(data => {
                setDataLength(data.data.response.count);
                setList(data && data.data && data.data.response ? data.data.response.rows : [])
                setLoader(false)
            }).catch(error => {
                console.log("error ====> ", error);
            })
        }
    }, [location, statsUpdate, sorting, search, globalSearch, params.pgno])


    const resetFilter = (e) => {
        e.preventDefault()
        setGlobalSearch("")
        setSearch({})
        setResetDate(!resetdate)
        $("#defaultstatus").prop("selectedIndex", 0)
    }

    const viewFunction = (row) => {
        navigate(`/admin/outlet-management/view/${row}?id=${companyId}`)
    }

    const handleSort = (e, column) => {
        setDefaultSorting(false);
        let sort = { order: 0, column: column };
        if (e.target.classList.contains("assc")) {
            sort.order = -1;
        } else {
            sort.order = 1;
        }
        setSorting(sort);
    }

    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }
        setSearch(sr);
    }

  return (
    <Layout>
       <Breadcrums data={breadcrumbs} />
        <div className="animation_fade">
            <div className="card custom-card overflow-hidden">
            <div className="card-body">
                <ViewAllDetails tab='outlets'/>
                <div className='d-flex justify-content-between align-items-center mb-4'>
                    <div className='d-flex align-items-center'>
                        <div className='form-group mb-0 me-3'>
                            <div className="form-group mb-0 rangepicker_container">
                                <i className="fa fa-search calender_icon"></i>
                                <input type="search" className="form-control" value={globalSearch} placeholder="Search" onChange={(e) => { setGlobalSearch(e.target.value) }} />
                            </div>
                        </div>
                        <div className="me-3">
                            <StatusFilter data={showFilterlist} prepareSearch={prepareSearch} />
                        </div>
                        <button type="reset" value='Reset' onClick={resetFilter} className="btn btn-warning float-right mr-2">Reset Filter</button>
                    </div>
                </div>
                <div className="table-responsive">
                    <table id="example-input" className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                        <thead>
                            <tr>
                                <th className="sr_head" width="10%">S.No</th>
                                <th width="15%">
                                    <div className='sorting_column'>
                                        <span>Company Name</span>
                                    </div>
                                </th>
                                <th width="15%">
                                    <div className='sorting_column'>
                                        <span>Brand</span>
                                    </div>
                                </th>
                                <th width="15%">
                                    <div className='sorting_column'>
                                        <span>Outlet Name</span>
                                        <Sorting sort={sorting} handleSort={handleSort} column="outlet_name" />
                                    </div>
                                </th>
                                <th width="15%">
                                    <div className='sorting_column'>
                                        <span>Outlet Name (Arabic)</span>
                                        <Sorting sort={sorting} handleSort={handleSort} column="outlet_name_ar" />
                                    </div>
                                </th>
                                <th className="created_head" width="8%">
                                    <div className='sorting_column'>
                                        <span>Created Date</span>
                                        <Sorting sort={sorting} handleSort={handleSort} defaultSorting={defaultSorting} column="created_at" />
                                    </div>
                                </th>
                                <th className='status_head' width="15%">Status</th>
                                <th className='action_head' width="8%">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                        {loader ?
                            <tr>
                                <td colSpan={8}><Loader /></td>
                            </tr> : <>
                        {list.length ? list.map((row, i) => (
                            <tr key={row.id}>
                                <td>{(params?.pgno * itemPerPage) - (itemPerPage) + (++i)}</td>
                                <td>{row.company.name}</td>
                                <td>{row.brand.name}</td>
                                <td>{row.outlet_name}</td>
                                <td>{row.outlet_name_ar}</td>
                                <td>{row.created_at ? formateDate(row.created_at) : "N/A"}</td>
                                <td>{row.status == 1 ? <span>Active</span> : <span>Inactive</span>}</td>
                                <td>
                                    <div className="d-flex">
                                        <button className="btn ripple btn-main-primary signbtn" onClick={() => { viewFunction(row.id) }}>View</button>
                                    </div>
                                </td>
                            </tr>
                            )) : <tr><td colSpan={8} className="text-center">No records</td></tr>}</>}
                        </tbody>
                    </table>
                </div>
                <div className="" id="example1_info" role="status" aria-live="polite"><b>Total Records : {dataLength ? dataLength : "0"}</b></div>
                {dataLength && dataLength > 0 ?
                <CustomPagination datalength={dataLength} itemperpage={itemPerPage} setPage={setPage} currentPage={page} pageRoute={[{ name: "outlet-management", path: `/admin/company/outlets/list/${params.id}` }]} /> : ""}
            </div>
            <div>
            </div>
            </div>
        </div>
    </Layout>
  );
}

export default OutletManagementTable
